export { default } from "./RequirementList";
